module.exports = __webpack_public_path__ + "img/HSR.5dfb79c2.svg";